import "babel-polyfill";
// import "./libs/swiper";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/custom-scrollbar";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import { goToAnchor } from "./modules/goToAnchor";
import { accordion } from "./modules/accordion";
import { featuredSlider } from "./modules/featuredSlider";
import { popupOpen } from "./modules/popups";
import { customSelect } from "./modules/customSelect";
import { openClose } from "./modules/openClose";
import { programSearchResults } from "./modules/programSearchResults";
import { featuredCarousel } from "./modules/featuredCarousel";
import { openCloseAddress } from "./modules/openCloseAddress";
import { postSlider } from "./modules/postSlider";
import { howWorkSlider } from "./modules/howWorkSlider";
import customScrollbar from "./modules/customScrollbar";
import { quoteSlider } from "./modules/quoteSlider";
import { tabs } from "./modules/tabs";
import { postCarousel } from "./modules/postCarousel";
import { openCloseFilter } from "./modules/openCloseFilter";
import { header } from "./modules/header";
import { locationSlider } from "./modules/locationSlider";
import { spotlightSlider } from "./modules/spotlightSlider";
import { studentsSlider } from "./modules/studentsSlider";
import { animationOnScroll } from "./modules/animationOnScroll";
import { programSearchForm } from "./modules/programSearchForm";
import { linksSection } from "./modules/linksSection";
import { popupLanguages } from "./modules/popupLanguages";
import { locationDots } from "./modules/locationDots";
import { requestInfoForm } from "./modules/requestInfoForm";
import { datepicker } from "./modules/datepicker";
import { inputPhoneFunction } from "./modules/inputPhoneFunction";
import { eventSlider } from "./modules/eventSlider";
import { checkAll } from "./modules/checkAll";


binder({
    bounds: {
        "html": [constants],
        "[data-goto-anchor]": goToAnchor,
        "body": popupLanguages,
        ".accordion": accordion,
        ".featured-slider": featuredSlider,
        ".popup-open, .languages-popup": popupOpen,
        "select": customSelect,
        ".open-close-link": openClose,
        ".program-search-results": programSearchResults,
        ".featured-carousel": featuredCarousel,
        ".offer-section": openCloseAddress,
        ".post-slider": postSlider,
        ".how-work-slider": howWorkSlider,
        ".custom-scrollbar": customScrollbar,
        ".quote-slider": quoteSlider,
        ".tabs": tabs,
        ".post-carousel": postCarousel,
        ".filter-aside": openCloseFilter,
        ".header": header,
        ".spotlight-section": spotlightSlider,
        ".students-slider": studentsSlider,
        ".has-animation": animationOnScroll,
        ".program-search-form": programSearchForm,
        ".links-section": linksSection,
        ".location": locationSlider,
        ".location-section": locationDots,
        ".request-info-form": requestInfoForm,
        ".datepicker": datepicker,
        "#phone": inputPhoneFunction,
        ".event-slider": eventSlider,
        ".check-all": checkAll,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js